export const BASE_HEIGHT = 1080;
export const BASE_WIDTH = 1920;
